// @flow
import React from 'react';

import { EDITORIAL_FOLDING_BLOCK } from 'Client/cms/toolkit/constants';
import { Line } from 'Components/frameworks/line/Line.jsx';
import { Panel } from './collapsePanel.descriptor';
import { editorialFoldingBlockResolver } from './editorialFoldingBlock.resolver';

export const editorialFoldingBlockDescriptor = {
  name: EDITORIAL_FOLDING_BLOCK,
  component: (props: *) => <Line component={Panel} props={props} />,
  props: editorialFoldingBlockResolver.props,
};
